import type {
  ListPublishedPostsResponse,
  PublishedPostsSort,
} from "@nlc/shared-types";
import type {
  InfiniteData,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";

import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";

import { socialPublishingKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

import type { InsightsFilters } from "../components/insights/insightsFilters";

const PUBLISHED_POSTS_PAGE_SIZE = 10;

export interface PublishedPostsQuery extends InsightsFilters {
  search: string;
  sort: PublishedPostsSort;
  timezone: string;
}

export function usePublishedPosts(
  query: PublishedPostsQuery,
): UseInfiniteQueryResult<InfiniteData<ListPublishedPostsResponse>, Error> {
  return useInfiniteQuery<ListPublishedPostsResponse>({
    getNextPageParam: ({ pagination }) =>
      pagination.page < pagination.totalPages ? pagination.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: keepPreviousData,
    queryFn: ({ pageParam }) =>
      apiClient
        .url("/social-publishing/published-posts")
        .query(
          Object.fromEntries(
            Object.entries({
              ...query,
              limit: PUBLISHED_POSTS_PAGE_SIZE,
              page: pageParam,
              search: query.search || undefined,
            }).filter(([, value]) => value !== undefined),
          ),
        )
        .get()
        .json(),
    queryKey: socialPublishingKeys.publishedPosts(query),
  });
}
